import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'earned' | 'locked';
  className?: string;
  style?: React.CSSProperties;
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', className = '', style }) => {
  const variantStyles: Record<string, string> = {
    default: '',
    earned: 'bg-amber-50 text-amber-700 border-amber-200',
    locked: 'bg-slate-100 text-slate-400 border-slate-200',
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold transition-colors ${variantStyles[variant]} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};
